import React from 'react'
import { IServiceTariffModel } from './ServiceTariffModel'
import DataTable, { TableAction, TableColumn } from '../../../../shared/components/DataTable'

type Props = {
  data: IServiceTariffModel[]
  currentPage: number
  totalPages: number
  onPageChange: (page: number) => void // Düzeltme: parametre tipi eklendi
  onEdit?: (serviceTariff: IServiceTariffModel) => void // Düzeltme: Edit fonksiyonu eklendi
  onDelete?: (serviceTariff: IServiceTariffModel) => void // Düzeltme: Delete fonksiyonu eklendi
  sortBy?: string // Düzeltme: Sort state'leri eklendi
  sortOrder?: 'asc' | 'desc'
  onSort?: (column: string, order: 'asc' | 'desc') => void
  loading?: boolean
}

export const ServiceTariffTable: React.FC<Props> = ({
  data,
  currentPage,
  totalPages,
  onPageChange,
  onEdit,
  onDelete,
  sortBy,
  sortOrder,
  onSort,
  loading = false
}) => {
  const serviceTariffColumns: TableColumn<IServiceTariffModel>[] = [
    
  ]

  
  const serviceTariffActions: TableAction<IServiceTariffModel>[] = [
    {
      label: 'Düzenle',
      icon: 'bi bi-pencil',
      className: 'btn-light-primary me-2',
      onClick: (serviceTariff) => onEdit?.(serviceTariff), // Düzeltme: Parent'tan gelen fonksiyon
    },
    {
      label: 'Sil',
      icon: 'bi bi-trash',
      className: 'btn-light-danger',
      onClick: (serviceTariff) => onDelete?.(serviceTariff), // Düzeltme: Parent'tan gelen fonksiyon
    },
  ]

  return (
    <DataTable
      data={data}
      columns={serviceTariffColumns}
      actions={serviceTariffActions}
      showPagination={true}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={onPageChange}
      sortBy={sortBy}
      sortOrder={sortOrder}
      onSort={onSort}
      loading={loading}
      emptyMessage='Henüz Sigorta Tarifesi bulunamadı'
    />
  )
}